import { toVector3 } from '@utils/conversion/toVector3'

export default function calculateWallPosition(start: [number, number], end: [number, number]) {
  const startPoint = toVector3([start[0], 0, start[1]])
  const endPoint = toVector3([end[0], 0, end[1]])
  const endMinusStart = endPoint.clone().sub(startPoint)
  const perpendicular = toVector3([endMinusStart.z, 0, -endMinusStart.x]).normalize().round()
  const endMinusStartMiddlePoint = endMinusStart.clone().multiplyScalar(0.5)
  const perpendicularOffset = perpendicular.clone().multiplyScalar(0.5)
  const finalfinalcenter = startPoint.clone().add(endMinusStartMiddlePoint).add(perpendicularOffset)
  return [finalfinalcenter.x, finalfinalcenter.z]
}
